/** Identifiants publics des messages d'information (alignés sur les GUID en base). */
export const MessageInformationGuids = {
    BtAjouterNoteFiche: '7c4e8f2a-1b3d-4e56-9f0a-2c8d6e1f4b90',
    BtEditionInlineEnregistrementAuto: 'b8d3f1e2-4c5a-6b7c-8d9e-0f1a2b3c4d5e',
    BdcEditionInlineEnregistrementAuto: 'a7c3e9f1-2b4d-4e68-9a0c-1d2e3f4a5b6c',
} as const;

export type MessageInformationGuid =
    (typeof MessageInformationGuids)[keyof typeof MessageInformationGuids];
